import create from 'zustand';
import { persist } from 'zustand/middleware';

// Local dependencies
import { BooleanString, ForwardMailFlow } from '../types';
import { WHO_IS_MOVING_CARD_VALUES } from '../constants/copy';
import { format } from 'date-fns';

interface ForwardMailUserDataStore extends ForwardMailFlow {
  setUserData: (userData: Record<string, unknown>) => void;
  resetUserData: () => void;
}

const defaultForwardMailUserDataStore: ForwardMailFlow = {
  addressesNormalized: BooleanString.FALSE,
  confirmAddresses: undefined,
  firstName: null,
  lastName: null,
  suffixName: undefined,
  middleName: undefined,
  forwardMailDate: '',
  stopForwardMailDate: undefined,
  isMoveTemporary: 'no',
  whosMoving: WHO_IS_MOVING_CARD_VALUES.INDIVIDUAL,
  review: undefined,
  businessName: undefined,
  phone: undefined,
  id: '',
  moveId: '',
  currentAddress: {
    street: '',
    unit: '',
    city: '',
    state: '',
    postalCode: '',
    normalizationResponse: undefined,
  },
  newAddress: {
    street: '',
    unit: '',
    city: '',
    state: '',
    postalCode: '',
    normalizationResponse: undefined,
  },
  isFileEdited: BooleanString.FALSE,
  isNewForm: BooleanString.FALSE,
  currentScreen: null,
  created_at: '',
  form_type: WHO_IS_MOVING_CARD_VALUES.INDIVIDUAL,
};

export const useForwardMailUserDataStore = create(
  persist<ForwardMailUserDataStore>(
    (set) => ({
      ...defaultForwardMailUserDataStore,
      setUserData: (userData: Record<string, unknown>) =>
        set((store) => {
          const state = { ...store, ...userData } as ForwardMailUserDataStore;
          if (state.forwardMailDate) {
            state.forwardMailDate = format(
              new Date(state.forwardMailDate),
              'MM/dd/yyyy'
            );
          }
          if (state.stopForwardMailDate) {
            state.stopForwardMailDate = format(
              new Date(state.stopForwardMailDate),
              'MM/dd/yyyy'
            );
          }
          return state;
        }),
      resetUserData: () =>
        set(() => {
          return { ...defaultForwardMailUserDataStore };
        }),
    }),
    {
      name: 'FYM_STORE',
      // @ts-expect-error FIXME: TS2322 - strict mode migration
      getStorage: () => (typeof window !== 'undefined' ? localStorage : null),
    }
  )
);
